<template>
  <div>
    <v-main>
      <ParentsRecordContainer />
    </v-main>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from "vue";
import ParentsRecordContainer from '@/container/records/ParentsRecordContainer.vue';

export default defineComponent({
  components: {
    ParentsRecordContainer,
  },
});
</script>
